export function contractorProfileComplete(user, includePhone = false) {
  if (user.bio && user.country && user.job_title && user.language && user.num_experience && user.skills
    && user.video && (includePhone ? (user.telephoneVerified === true && user.telephone !== undefined) : true)
  ) {
    return true
  } else {
    return false
  }
}

export function employerProfileComplete(user) {
  if (user?.plan) {
    // if (user?.emType === 'company') {
    //   if (user?.companyName && user?.country && user?.companySize && user?.industry && user?.website && user?.description) {
    //     return true
    //   } else {
    //     return false
    //   }
    // } else {
    //   return true
    // }
    if (user?.companyName && user?.country && user?.companySize && user?.industry && user?.website && user?.description) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}